import { createSlice } from '@reduxjs/toolkit';

const schoolsSlice = createSlice({
    name: 'schools',
    initialState: {
        selectedSchool: 0,
        selectedSchoolName:''
    },
    reducers: {
        setSelectedSchool: (state, action) => {
            state.selectedSchool = action.payload; 
        },
        setSelectedSchoolName: (state, action) => {
            state.selectedSchoolName = action.payload;
        },
    },
});

export const { setSelectedSchool, setSelectedSchoolName } = schoolsSlice.actions;

export default schoolsSlice.reducer;
